import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { PropType, ref } from "vue";
import ModalBox from "@/components/v2/Modal/ModalBox.vue";
import { useTasksStore } from "@/stores/v2";

// Store

export default /*@__PURE__*/_defineComponent({
  __name: 'CommentsModal',
  props: {
  showModal: {
    type: Boolean,
    default: false,
  },
  toggleCommentsModal: {
    type: Function as PropType<(payload: MouseEvent) => void>,
    required: true,
  },
},
  setup(__props) {

const tasksStore = useTasksStore();
// Props

// State
const comment = ref("");

const addCommentOnTask = () => {
  if (tasksStore.activeTask) {
    tasksStore.activeTask.comment = comment.value;
  }
};

return (_ctx: any,_cache: any) => {
  return (__props.showModal)
    ? (_openBlock(), _createBlock(ModalBox, {
        key: 0,
        onClose: __props.toggleCommentsModal
      }, {
        header: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Leave a comment ")
        ])),
        main: _withCtx(() => [
          _withDirectives(_createElementVNode("textarea", {
            class: "w-full h-28 rouned resize-none p-2 outline-secondary border border-gray-400",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comment).value = $event)),
            onInput: addCommentOnTask
          }, null, 544), [
            [_vModelText, comment.value]
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (__props.toggleCommentsModal && __props.toggleCommentsModal(...args))),
            type: "button",
            class: "text-white bg-primary focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover: focus:z-10"
          }, " Save "),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (__props.toggleCommentsModal && __props.toggleCommentsModal(...args))),
            type: "button",
            class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10"
          }, " Close ")
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}
}

})